import { Link } from "react-router-dom";
import { LogOut } from "lucide-react";
import { QUICK_EXIT_URL } from "@/lib/site";

export const UrgentBar = () => (
  <div className="bg-clay-dark text-white text-sm no-print" data-testid="urgent-help-bar">
    <div className="container-site flex items-center justify-between gap-3 py-2">
      <p className="leading-snug">
        <span className="font-semibold">In immediate danger?</span>{" "}
        <a href="tel:999" className="underline underline-offset-2 font-semibold" data-testid="urgent-bar-999">Call 999</a>
        <span className="hidden sm:inline"> · Urgent medical advice: <a href="tel:111" className="underline underline-offset-2">NHS 111</a></span>
        {" · "}
        <Link to="/urgent-help" className="underline underline-offset-2" data-testid="urgent-bar-link">Urgent help</Link>
      </p>
      <button
        type="button"
        onClick={() => window.location.replace(QUICK_EXIT_URL)}
        className="inline-flex shrink-0 items-center gap-1.5 rounded-full bg-black/20 px-3 py-1.5 min-h-[36px] font-semibold hover:bg-black/30 transition-colors"
        data-testid="quick-exit-button"
        aria-label="Quick exit: leave this site immediately"
      >
        <LogOut className="h-4 w-4" aria-hidden="true" /> Quick exit
      </button>
    </div>
  </div>
);
